module.exports = __webpack_public_path__ + "static/media/cash.0e8afb5c.svg";